import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {Strenger} from "../Strenger";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {BasisRessurs} from "../../infrastruktur/BasisRessurs";
import {erLikIgnorerCasing} from "../../stoettefunk/strenger";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";
import {Debugger} from "debug";
import {Språk} from "../i18n/Spraak";
import {uriEnkodet} from "felles/stoettefunk/uri";
import IResourceArray = ng.resource.IResourceArray;
import AgendaDokumentValgSpesifikasjon = l.AgendaDokumentValgSpesifikasjon;
import ForfalteOppgaverDokumentSpesifikasjon = l.ForfalteOppgaverDokumentSpesifikasjon;

const debug: Debugger = require('debug')('GruppeRessurs');

export class GruppeRessurs extends BasisRessurs<l.GruppeModell> {

    static regNavn = "gruppeRessurs";

    static forInjisering() {
        return [
            "$resource",
            Konfigurasjon.regNavn,
            Strenger.regNavn,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            GruppeRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                private konfigurasjon: Konfigurasjon,
                private strenger: Strenger,
                ressursFeilhåndtering: RessursFeilhåndtering,
                gettextCatalog: gettextCatalog) {
        super('gruppe',
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                opprettGruppeOgBruker: {method: 'PUT', url: '/api/gruppe/opprettGruppeOgBruker', params: {id: ''}},
                opprettGruppeMedInnloggetBruker: {method: 'PUT', url: '/api/gruppe/opprettGruppeMedInnloggetBruker', params: {id: ''}},
                opprettAvtaleOgGruppeMedInnloggetBruker: {method: 'PUT', url: '/api/gruppe/opprettAvtaleOgGruppeMedInnloggetBruker', params: {id: ''}},
                oppdaterTillatteAutentiseringsmetoder: {method: 'POST', url: '/api/gruppe/:id/oppdaterTillatteAutentiseringsmetoder', params: {id: '@id'}},
                oppdaterMøtevurderingAktivert: {method: "POST", url: '/api/gruppe/:id/oppdaterMoetevurderingAktivert', params: {id: '@id'}},
                oppdaterSpraak: {method: "POST", url: '/api/gruppe/:id/oppdaterSpraak', params: {id: '@id'}},
                oppdaterAgendaDokumentValg: {method: "POST", url: '/api/gruppe/:id/oppsett/agendadokument', params: {id: '@id'}},
                oppdaterForfalteOppgaverDokumentValg: {method: "POST", url: '/api/gruppe/:id/oppsett/forfalteOppgaverDokument', params: {id: '@id'}},
                opprettAksjeeierbok: {method: 'POST', url: '/api/gruppe/:id/opprettAksjeeierbok', params: {id: '@id'}, isArray: false},
                finnAlle: {method: 'GET', url: '/api/gruppe/finnAlle', isArray: true},
                gruppeAggregaterForAvtale: {method: 'GET', url: '/api/gruppe/gruppeAggregaterForAvtale/:avtaleId',params: {avtaleId: '@avtaleId'}, isArray: false},
                gruppeAggregaterForGruppe: {method: 'GET', url: '/api/gruppe/:id/gruppeAggregater', params: {id: ''}, isArray: false},
                finnTilgjengeligeRoller: {method: 'GET', url: '/api/gruppe/:id/finnTilgjengeligeRoller', isArray: true},
                finnTilgjengeligeMedlemmer: {method: 'GET', url: '/api/gruppe/:id/finnTilgjengeligeMedlemmer', isArray: true},
                finnTilgjengeligeGrupper: {method: 'GET', url: '/api/gruppe/finnTilgjengeligeGrupper', isArray: true},
                finnMøteVurderinger: {method: 'GET', url: '/api/gruppe/:id/finnMoeteVurderinger', params: {id: ''}, isArray: true},
                finnMalgrupper: {method: 'GET', url: '/api/gruppe/finnMalgrupper', params: {id: ''}, isArray: true},
                medlemMedBrukerId: {method: 'GET', url: '/api/gruppe/:gruppeId/medlemMedBrukerId/:brukerId', params: {brukerId: '@brukerId',gruppeId:'@gruppeId'}, isArray: false},
                hentRedigerSakKontekst: {method: 'GET', url: '/api/gruppe/:id/hentRedigerSakKontekst', params: {id: ''}}
            });
    }

    //offentlige metoder


    opprettGruppeMedInnloggetBruker(spesifikasjon: l.NyGruppeSpesifikasjon): l.GruppeModell {
        debug("opprettGruppeMedInnloggetBruker", spesifikasjon);
        return this.ressurs['opprettGruppeMedInnloggetBruker'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke registrere ny gruppe"))
        );
    }

    opprettAvtaleOgGruppeMedInnloggetBruker(spesifikasjon: l.NyAvtaleOgGruppeSpesifikasjon): l.GruppeModell {
        debug("opprettAvtaleOgGruppeMedInnloggetBruker", spesifikasjon);
        return this.ressurs['opprettAvtaleOgGruppeMedInnloggetBruker'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke registrere ny gruppe"))
        );
    }

    opprettGruppeOgBruker(spesifikasjon: l.NyBrukerOgAvtaleOgGruppeSpesifikasjon): l.GruppeMedlemModell {
        debug("opprettGruppeOgBruker", spesifikasjon);
        return this.ressurs["opprettGruppeOgBruker"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke registrere ny gruppe"))
        );
    }

    oppdaterTillatteAutentiseringsmetoder(gruppeId: string, spesifikasjon: l.TillatteAutentiseringsmetoderSpesifikasjon): l.TillatteAutentiseringsmetoderOppdatertModell {
        debug("oppdaterTillatteAutentiseringsmetoder", gruppeId, spesifikasjon);
        return this.ressurs["oppdaterTillatteAutentiseringsmetoder"](
            _.defaults({id: gruppeId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere gruppe"))
        );
    }
    oppdaterMøtevurderingAktivert(gruppeId: string, aktivert: boolean): l.AngularRessurs<any> {
        return this.ressurs["oppdaterMøtevurderingAktivert"](
          _.defaults({id: gruppeId}, {aktivert: aktivert}),
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere gruppe")));
    }

    oppdaterSpråk(gruppeId: string, språk: Språk): l.AngularRessurs<any> {
        return this.ressurs["oppdaterSpraak"](
          _.defaults({id: gruppeId}, {spraak: (språk.servertag)}),
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere gruppe med valgt språk")));
    }


    opprettAksjeeierbok(gruppeId: string): l.GruppeModell {
        debug("opprettAksjeeierbok", gruppeId);
        return this.ressurs['opprettAksjeeierbok'](
          {id:gruppeId},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette aksjeeierbok for gruppe"))
        );
    }

    finnAlle(): l.AdminEnkelGruppeModell[] {
        debug("finnAlle");
        return this.ressurs["finnAlle"](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste alle grupper"))
        );
    }

    gruppeAggregaterForAvtale(avtaleId: string): l.GrupperAggreatModell {
        debug("gruppeAggregaterForAvtale");
        return this.ressurs["gruppeAggregaterForAvtale"](
            {avtaleId: avtaleId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste gruppeaggregater"))
        );
    }

    gruppeAggregaterForGruppe(gruppeId: string): l.AngularRessurs<l.GruppeAggreatModell> {
        debug("gruppeAggregaterForGruppe");
        return this.ressurs["gruppeAggregaterForGruppe"](
            {id: gruppeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste gruppeaggregater"))
        );
    }

    finnTilgjengeligeRoller(gruppeId: string, vedOk: (roller: l.MedlemsRolleModell[]) => void = _.noop): l.MedlemsRolleModell[] {
        debug("finnTilgjengeligeRoller", gruppeId);
        return this.ressurs["finnTilgjengeligeRoller"](
            {id: gruppeId},
            vedOk,
            this.håndterFeil(() => this.gettextCatalog.getString("Kunne ikke finne tilgjengelige roller for gruppe {{id}}", {id:gruppeId}))
        );
    }

    finnTilgjengeligeMedlemmer(gruppeId: string, vedOk: (medlemmer: l.GruppeMedlemListeModell[]) => void = _.noop): l.GruppeMedlemListeModell[] {
        debug("finnTilgjengeligeMedlemmer", gruppeId);
        return this.ressurs["finnTilgjengeligeMedlemmer"](
            {id: gruppeId},
            vedOk,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke finne tilgjengelige medlemmer i gruppe {{id}}', {id:gruppeId}))
        );
    }

    finnTilgjengeligeGrupper(): IResourceArray<l.GruppeModell> {
        debug("finnTilgjengeligeGrupper");
        return this.ressurs["finnTilgjengeligeGrupper"](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne tilgjengelige grupper"))
        );
    }

    finnMøteVurderinger(gruppeId: string, start: Date, slutt: Date, vedOk: (grupper: l.MøtevurderingerModell[]) => void = _.noop): any[] {
        debug("finnMøteVurderinger", gruppeId, start, slutt);
        return this.ressurs["finnMøteVurderinger"](
            {id: gruppeId, start: start, slutt: slutt},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møtevurderinger"))
        );
    }

    medlemMedBrukerId(gruppeId: string, brukerId: string): l.GruppeMedlemModell {
        debug("medlemMedBrukerId", gruppeId, brukerId);
        return this.ressurs["medlemMedBrukerId"](
          {gruppeId: gruppeId, brukerId: brukerId},
          _.noop,
          // ikke logg 404 til server, brukes i hedelseslogg, er ikke sikkert medlem er opprettet ennå
          this.ressursFeilhåndtering.håndterRequestFeil(() => this.gettextCatalog.getString("Kunne ikke finne gruppemedlem"),
            feil => feil.status === 401 || feil.status === 500 || feil.status === 404,
            feil => feil.status === 401 || feil.status === 500 || feil.status === 404)
        );
    }

    finnMalgrupper(): IResourceArray<l.EnkelGruppeModell> {
        debug("finnMalgrupper");
        return this.ressurs["finnMalgrupper"](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne malgrupper"))
        );
    }

    hentRedigerSakKontekst(gruppeId: string, vedOk: (entitet: l.RedigerSakKontekst) => void = _.noop) {
        debug("hentRedigerSakKontekst", gruppeId);
        return this.ressurs["hentRedigerSakKontekst"](
            {id: gruppeId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste rediger sak kontekst"))
        );
    }

    oppdaterAgendaDokumentValg(gruppeId: string, spesifikasjon: AgendaDokumentValgSpesifikasjon) {
        debug("oppdaterAgendaDokumentValg", gruppeId);
        return this.ressurs["oppdaterAgendaDokumentValg"](
            _.defaults({id: gruppeId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere agendadokument-valg"))
        );
    }

    oppdaterForfalteOppgaverDokumentValg(gruppeId: string, spesifikasjon: ForfalteOppgaverDokumentSpesifikasjon) {
        debug("oppdaterForfalteOppgaverDokumentValg", gruppeId);
        return this.ressurs["oppdaterForfalteOppgaverDokumentValg"](
            _.defaults({id: gruppeId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere oppgavedokument-valg"))
        );
    }

    eksporterMøteDeltakelseUrl(gruppeId: string, fraOgMed: Date, tilOgMed: Date) {
        const fom = uriEnkodet(fraOgMed.toISOString());
        const tom = uriEnkodet(tilOgMed.toISOString());
        return `${this.konfigurasjon.serviceRotUrl}/api/gruppe/${gruppeId}/moetedeltakelse.xlsx?fom=${fom}&tom=${tom}`;
    }

    //statiske hjelpemetoder

    public gruppedumpUrl(gruppe: l.GruppeModell) {
        return `${this.konfigurasjon.serviceRotUrl}/api/gruppe/${gruppe.id}/datadump/${gruppe.tittel}.zip`
    }

    medlemmersFornavn(gruppe: l.GruppeModell) {
        return this.strenger.listeTilStreng(
            <string[]>_(gruppe.medlemmer).map(medlem => this.strenger.førsteOrd(medlem.navn)).value(),
            ",",
            this.gettextCatalog.getString('og'));
    }

    static fullverdigeMedlemmer(gruppe: l.GruppeModell) {
        return gruppe.medlemmer.filter(medlem => medlem.invitasjonsstatus === l.Invitasjonsstatus.akseptert);
    }

    /** Medlemmer som har akseptert invitasjon men som har ikke har tilgang (anonymiserte er utelatt) */
    static inaktiveFullverdigeMedlemmer(gruppe: l.GruppeModell) {
        return gruppe.inaktiveMedlemmer.filter(medlem => medlem.invitasjonsstatus === l.Invitasjonsstatus.akseptert && !medlem.anonymisert);
    }

    static anonymiserteMedlemmer(gruppe: l.GruppeModell) {
        return gruppe.inaktiveMedlemmer.filter(medlem => medlem.anonymisert);
    }

    static validerEksistererMedlemEllerInvitasjonMedEpost(gruppe: l.GruppeModell, epost: string): MedlemEpostValideringsfeil|null {
        if (GruppeRessurs.eksistererMedlemMedEpost(gruppe, epost)) return MedlemEpostValideringsfeil.eksistererMedlemMedEpost;
        if (GruppeRessurs.eksistererInaktivtMedlemMedEpost(gruppe, epost)) return MedlemEpostValideringsfeil.eksistererInaktivtMedlemMedEpost;
        if (GruppeRessurs.eksistererInvitasjonMedEpost(gruppe, epost)) return MedlemEpostValideringsfeil.eksistererInvitasjonMedEpost;
        return null;
    }

    static eksistererMedlemMedEpost(gruppe: l.GruppeModell, epost: string): boolean {
        return GruppeRessurs.fullverdigeMedlemmer(gruppe)
            .some(medlem => erLikIgnorerCasing(medlem.epost, epost));
    }

    static eksistererInaktivtMedlemMedEpost(gruppe: l.GruppeModell, epost: string): boolean {
        return gruppe.inaktiveMedlemmer.some(medlem => erLikIgnorerCasing(medlem.epost, epost))
    }

    static eksistererInvitasjonMedEpost(gruppe: l.GruppeModell, epost: string): boolean {
        return gruppe.invitasjoner.some(invitasjon => erLikIgnorerCasing(invitasjon.epost, epost))
    }

    static antallMedlemmer(gruppe: l.GruppeModell): number {
        var antall = gruppe.medlemmer.filter((medlem) => medlem.brukerId !== null).length;
        return antall;
    }

    static antallInviterte(gruppe: l.GruppeModell): number {
        var antall = gruppe.invitasjoner.filter((invitasjon) => _.includes([l.Invitasjonsstatus.ikke_sendt, l.Invitasjonsstatus.sendt], invitasjon.status)).length;
        return antall;
    }

    static gruppelogoSti(gruppeId: string, logoId: string, bredde = 40) {
        return `/api/gruppe/${gruppeId}/logo/${logoId}?format=png&bredde=${bredde}`;
    }
}

/** merk at tekstrepresentasjonene av enuminnslagene brukes i gui og må derfor endres med varsomhet */
export enum MedlemEpostValideringsfeil {
    eksistererMedlemMedEpost = 'eksistererMedlemMedEpost',
    eksistererInvitasjonMedEpost = 'eksistererInvitasjonMedEpost',
    eksistererInaktivtMedlemMedEpost = 'eksistererInaktivtMedlemMedEpost'
}
